import { Box, Flex } from '@fundamentals'
import React from 'react'

type ComponentProps = {
  open: boolean
  component: React.ReactNode
  children: React.ReactNode
}

export const WithSwitchLayout: React.FC<ComponentProps> = ({
  open,
  component,
  children,
}) => {
  return (
    <Flex>
      <Box
        sx={{
          width: !open ? '100%' : '0%',
          opacity: !open ? 1 : 0,
          transition: 'width 0.6s ease-in-out, opacity 0.5s ease-in-out',
        }}
      >
        {children}
      </Box>
      <Box
        sx={{
          width: open ? '100%' : '0%',
          opacity: open ? 1 : 0,
          transition: 'width 0.6s ease-in-out, opacity 0.5s ease-in-out',
        }}
      >
        {open && component}
      </Box>
    </Flex>
  )
}
